import { Image, ImageProps, Stack } from '@optimus-web/core';
import { ImageWrap, PropertyName } from './style';

interface PropertyLogoProps<T> {
    image: string;
    propertyName: string;
    imageProps?: T;
    isMobile?: boolean;
}

interface PropertyLogoFactory {
    ImageComponent?: React.ComponentType<ImageProps>;
}

export const propertyLogoFactory =
    <T,>({ ImageComponent = Image }: PropertyLogoFactory = {}) =>
    ({ image, propertyName, imageProps, isMobile, ...other }: PropertyLogoProps<T>) => (
        <Stack spacing="300" itemAlignment="center" {...other}>
            {isMobile !== true && (
                <ImageWrap>
                    <ImageComponent src={image} alt={propertyName} {...imageProps} />
                </ImageWrap>
            )}
            <PropertyName isMobile={isMobile}>{propertyName}</PropertyName>
        </Stack>
    );

export const PropertyLogo = propertyLogoFactory();
